import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 3H2.5C2.22386 3 2 3.22386 2 3.5V12.5C2 12.7761 2.22386 13 2.5 13H13.5C13.7761 13 14 12.7761 14 12.5V3.5C14 3.22386 13.7761 3 13.5 3Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 10.4999L5.14644 7.35348C5.19287 7.30705 5.24799 7.27022 5.30865 7.24509C5.36931 7.21996 5.43433 7.20703 5.49999 7.20703C5.56565 7.20703 5.63067 7.21996 5.69133 7.24509C5.752 7.27022 5.80711 7.30705 5.85354 7.35348L8.64644 10.1464C8.69287 10.1928 8.74799 10.2296 8.80865 10.2548C8.86931 10.2799 8.93433 10.2928 8.99999 10.2928C9.06565 10.2928 9.13067 10.2799 9.19133 10.2548C9.252 10.2296 9.30711 10.1928 9.35354 10.1464L10.6464 8.85348C10.6929 8.80705 10.748 8.77022 10.8086 8.74509C10.8693 8.71996 10.9343 8.70703 11 8.70703C11.0657 8.70703 11.1307 8.71996 11.1913 8.74509C11.252 8.77022 11.3071 8.80705 11.3535 8.85348L14 11.4999",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 7C10.1642 7 10.5 6.66421 10.5 6.25C10.5 5.83579 10.1642 5.5 9.75 5.5C9.33579 5.5 9 5.83579 9 6.25C9 6.66421 9.33579 7 9.75 7Z",
			fill: "currentColor"
		})
	]
});
export default SvgImage;
